// Check auth BEFORE loading React
const path = window.location.pathname;
const urlParams = new URLSearchParams(window.location.search);
const isAuthCallback = path === '/auth/login' && (urlParams.has('code') || urlParams.has('error'));
const token = localStorage.getItem('ttx_auth_token');
const hasValidToken = token && token !== 'null' && token !== 'undefined';

const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
const redirectUri = import.meta.env.VITE_COGNITO_REDIRECT_SIGNIN;
const cognitoConfigured = cognitoDomain && clientId && redirectUri;

if (!isAuthCallback && !hasValidToken && cognitoConfigured) {
  // Redirect to Cognito immediately - don't even load React
  const authUrl = new URL(`https://${cognitoDomain}/login`);
  authUrl.searchParams.set('client_id', clientId);
  authUrl.searchParams.set('response_type', 'code');
  authUrl.searchParams.set('scope', 'openid email profile');
  authUrl.searchParams.set('redirect_uri', redirectUri + '/auth/login');
  window.location.href = authUrl.toString();
} else {
  // Only load React if we have a token to verify or handling callback
  import('react').then((React) => {
    import('react-dom/client').then((ReactDOM) => {
      import('./App.jsx').then(({ default: App }) => {
        import('./index.css');
        import('./analytics/posthog').then(({ initPostHog }) => {
          initPostHog();
        });

        ReactDOM.createRoot(document.getElementById('root')).render(
          <React.StrictMode>
            <App />
          </React.StrictMode>,
        );
      });
    });
  });
}
